/**
 * Nordic Park — Product FAQ Accordion
 */
(function () {
  document.querySelectorAll('.np-faq .np-faq__question').forEach(function (button) {
    button.addEventListener('click', function () {
      var item = button.closest('.np-faq__item');
      var isOpen = item.classList.contains('is-open');

      // Close all
      document.querySelectorAll('.np-faq .np-faq__item.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
        openItem.querySelector('.np-faq__question').setAttribute('aria-expanded', 'false');
      });

      // Toggle clicked
      if (!isOpen) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();
